export default "__VITE_ASSET__CafAAASM__"